import { Action } from '@ngrx/store';
import { User } from '@digitaix/types';

export enum UserActionTypes {
  SetUser = '@digitaix/core/authentication/SET_USER',
  SendVerificationEmail = '[Auth] Send Verification Email',
}

export class SendVerificationEmail implements Action {
  public readonly type = UserActionTypes.SendVerificationEmail;

  constructor() {}
}

export class SetUser<U extends User = User> implements Action {
  public readonly type = UserActionTypes.SetUser;

  constructor(public user: U | null | false) {}
}

export class UserEffectsInit implements Action {
  public static TYPE = '@digitaix/core/authentication/USER_EFFECTS_INIT';
  public readonly type = UserEffectsInit.TYPE;

  constructor() {}
}

export type UserActions = SetUser | SendVerificationEmail;
